import * as ngCore from '@angular/core'
import * as ngxMarkdown from 'ngx-markdown'

import { Extension } from './extension'

/**
 * Wrapper for {@link ngxMarkdown.MarkdownComponent} with support for our custom
 * {@link Extension}
 */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [ngxMarkdown.MarkdownComponent],
  selector: 'atn-markdown',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Markdown content to render (reactive input)
   */
  public readonly data = ngCore.input<string>('')

  /**
   * Used by {@link onReady}
   */
  @ngCore.ViewChild(ngxMarkdown.MarkdownComponent, { static: true })
  private readonly _markdownComponent: ngxMarkdown.MarkdownComponent | undefined

  /** Notifies parent when markdown is fully rendered */
  @ngCore.Output()
  public readonly ready = new ngCore.EventEmitter<void>()

  /**
   * @see {@link Extension.init}
   */
  public onReady(): void {
    if (this._markdownComponent) {
      for (const extension of Extension.ALL_INSTANCES) {
        extension.init(this._markdownComponent.element.nativeElement)
      }
      this.ready.emit()
    }
  }
}
